import { z } from 'zod';
import { ButtonTheme } from '../components/ButtonTheme';

const ThemedTextSchema = z
  .object({
    fontFamily: z.string().optional(),
    fontSize: z.string().optional(),
    fontWeight: z.string().optional(),
    lineHeight: z.string().optional(),
    letterSpacing: z.string().optional(),
    color: z.string().optional(),
    textTransform: z.string().optional()
  })
  .optional();

const ThemedTextSelectorsSchema = z
  .object({
    display: ThemedTextSchema,
    h1: ThemedTextSchema,
    h2: ThemedTextSchema,
    h3: ThemedTextSchema,
    h4: ThemedTextSchema,
    h5: ThemedTextSchema,
    h6: ThemedTextSchema,
    paragraph: ThemedTextSchema,
    caption: ThemedTextSchema,
    dek: ThemedTextSchema,
    breadcrumb: ThemedTextSchema,
    runningLane: ThemedTextSchema
  })
  .optional();

const ThemeLinkPropertiesSchema = z
  .object({
    color: z.string().optional(),
    opacity: z.string().optional()
  })
  .optional();

export const PageCollectionThemeSchema = z.object({
  general: z
    .object({
      backgroundColor: z.string().optional(),
      foregroundColor: z.string().optional(),
      imageBorderRadius: z.string().optional(),
      spacerMultiplierDesktop: z.string().or(z.number()).optional(),
      spacerMultiplierMobile: z.string().or(z.number()).optional()
    })
    .optional(),
  text: z
    .object({
      desktop: ThemedTextSelectorsSchema,
      mobile: ThemedTextSelectorsSchema
    })
    .optional(),
  link: z
    .object({
      text: ThemeLinkPropertiesSchema,
      hoverFocus: ThemeLinkPropertiesSchema,
      active: ThemeLinkPropertiesSchema,
      textTransform: z.string().optional()
    })
    .optional(),
  button: ButtonTheme.optional()
});

export type PageCollectionTheme = z.infer<typeof PageCollectionThemeSchema>;
